import React from 'react';

const TrackOrderPage = () => {
  return (
    <div className="public-website">
      <div className="container">
        <h1>Track Order Page</h1>
        <p>Order tracking page coming soon...</p>
      </div>
    </div>
  );
};

export default TrackOrderPage; 